import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { StaticPage } from '../../containers';
import { IconSpinner } from '../../components';
import { adminPageHOC } from '../../util/contextHelpers';

import css from './AdminSocialReviewerPage.css';

/**
 * FullscreenAdminShell — the ONE chrome-less page holder for every full-screen
 * admin-social takeover (the reviewer and the Workflow Studio).
 *
 * It is deliberately CHROME-LESS: unlike the marketplace AdminPageHolder it does
 * NOT mount the Topbar/Footer. Those would otherwise sit above the takeover via
 * --zIndexTopbar/--zIndexGenericError and reintroduce the very chrome these
 * surfaces escape — and the Topbar's client-only GenericError banner is the
 * source of the SSR/client hydration mismatch on these routes (each takeover's
 * heavy subtree is SSR-safe behind its own *ClientOnly mount guard).
 *
 * It keeps everything a takeover actually needs:
 *   - StaticPage (the Page SSR doc shell: <title>, robots noindex, scroll state),
 *   - adminPageHOC gating (non-admins are redirected to the landing page),
 *   - currentUser + history injected into the child (same contract as the dashboard).
 *
 * One shell, not two: AdminSocialReviewerPage and AdminSocialWorkflowPage both
 * mount through here (Lycatra value-2 "extend, don't fork").
 */
const FullscreenAdminShell = ({
    currentUser,
    history,
    currentUserRequestInProgress,
    children,
    title = 'AdminSocialPage',
    schema = {},
}) => (
    <StaticPage title={title} schema={schema} metaTags={[{ name: 'robots', content: 'noindex' }]}>
        {currentUserRequestInProgress ? (
            <div className={css.bootPlaceholder}>
                <IconSpinner />
            </div>
        ) : (
            React.Children.map(children, child =>
                React.cloneElement(child, { currentUser, history })
            )
        )}
    </StaticPage>
);

const mapStateToProps = ({ user: { currentUser, currentUserRequestInProgress } }) => ({
    currentUser,
    currentUserRequestInProgress,
});

export default compose(withRouter, connect(mapStateToProps))(adminPageHOC(FullscreenAdminShell));
